import * as React from 'react';
import {NavLink, useLocation} from 'react-router-dom';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import LibraryMusicRoundedIcon from '@mui/icons-material/LibraryMusicRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import {SvgIconComponent} from '@mui/icons-material';
import styles from './BottomNav.module.scss';

interface NavItem {
    to: string;
    label: string;
    icon: SvgIconComponent;
    match: (pathname: string) => boolean;
}

const items: NavItem[] = [
    {to: '/', label: 'Home', icon: HomeRoundedIcon, match: p => p === '/'},
    {to: '/search', label: 'Search', icon: SearchRoundedIcon, match: p => p.startsWith('/search')},
    {to: '/library', label: 'Library', icon: LibraryMusicRoundedIcon, match: p => p.startsWith('/library') || p.startsWith('/playlists')},
    {to: '/profile', label: 'Profile', icon: PersonRoundedIcon, match: p => p.startsWith('/profile')},
];

export const BottomNav: React.FC = () => {
    const {pathname} = useLocation();

    return (
        <nav className={styles.bottomNav} aria-label="Primary">
            <div className={styles.bottomNav__bar}>
                {items.map(item => {
                    const active = item.match(pathname);
                    const Icon = item.icon;
                    return (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            className={`${styles.bottomNav__item} ${active ? styles.bottomNav__itemActive : ''}`}
                            aria-current={active ? 'page' : undefined}
                        >
                            <span className={styles.bottomNav__iconWrap}>
                                <Icon className={styles.bottomNav__icon}/>
                            </span>
                            <span className={styles.bottomNav__label}>{item.label}</span>
                        </NavLink>
                    );
                })}
            </div>
        </nav>
    );
};
